<script>
  export default {
    name: 'VGridformBuilderTour',
    data() {
      return {
        steps: [
          {
            target: '#vgfb-tpl-import',
            header: {
              title: 'Vorlage importieren'
            },
            content: 'Hier können Sie eine bereits existierende Vorlage importieren.',
            params: {
              placement: 'bottom-end'
            }
          },
          {
            target: '#vgfb-group-import',
            header: {
              title: 'Bausteingruppe importieren'
            },
            content: 'Hier können Sie eine bereits existierende Bausteingruppe importieren.',
            params: {
              placement: 'bottom-end'
            }
          },
          {
            target: '#vgfb-block-import',
            header: {
              title: 'Baustein importieren'
            },
            content: 'Hier können Sie einen bereits existierenden Baustein importieren.',
            params: {
              placement: 'bottom-end'
            }
          },
          {
            target: '#vgfb-type-select',
            header: {
              title: 'Feldtyp auswählen'
            },
            content: 'Wählen Sie einen vordefinierten Feldtypen aus und gestalten einen Baustein nach Ihren Wünschen.',
            params: {
              placement: 'left-end'
            }
          },
          {
            target: '#vgfb-toolbar',
            header: {
              title: 'Funktionen'
            },
            contents: [
              '- Automatische Bearbeitung ein-/ausschalten',
              '- Bausteingruppen ein-/ausklappen',
              '- Vorhandene Bausteine entfernen',
              '- Bausteine selektieren und Gruppen erstellen',
              '- Bausteine für die spätere Nutzung speichern',
              '- Letzte Änderung(en) rückgängig machen',
              '- Informationen zur Tastaturbedienung'
            ],
            params: {
              placement: 'bottom'
            }
          },
          {
            target: '.vgf__fh-handle',
            header: {
              title: 'Verschieben'
            },
            content: 'Halten Sie die Maus gedrückt und verschieben die Bausteingruppe an eine andere Position.',
            params: {
              placement: 'bottom-end'
            }
          }
        ],
        callbacks: {
          onStart: () => {
            this.$emit('started')
          },
          onNextStep: step => {
            // console.log('step', step, this.steps[step])
          },
          onStop: () => {
            this.$emit('finished')
          }
        }
      }
    }
  }
</script>

<template>
  <v-tour name="vgfbTour" :steps="steps" :callbacks="callbacks"></v-tour>
</template>
